import { useState } from 'react';
export const useDocumentEditButton = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  return {
    anchorEl,
    setAnchorEl,
  };
};
